import fetch from "logic/rest/FetchProvider";
import * as URLUtils from "util/URLUtils";
const startJobUrl = (id) => URLUtils.qualifyUrl(`/views/search/${id}/execute`);
const cancelJobUrl = (nodeId, jobId) => URLUtils.qualifyUrl(`/views/searchjobs/${nodeId}/${jobId}/cancel`);
const pollJobUrl = (nodeId, jobId, page, perPage) => URLUtils.qualifyUrl(
  `/views/searchjobs/${nodeId}/${jobId}/status${page && perPage ? `?page=${page}&per_page=${perPage}` : ""}`
);
export function runStartJob(search, executionState) {
  return fetch("POST", startJobUrl(search.id), JSON.stringify(executionState));
}
export function runPollJob({
  jobIds: { nodeId, asyncSearchId },
  page,
  perPage
}) {
  return fetch("GET", pollJobUrl(nodeId, asyncSearchId, page, perPage));
}
export function runCancelJob({ nodeId, asyncSearchId }) {
  return fetch("DELETE", cancelJobUrl(nodeId, asyncSearchId));
}
